import moment from "moment";
import { useTranslation } from "react-i18next";
import { TableCell } from "../../../components/table/table-cell/table-cell";
import InfinityTable from "../../../components/infinity-table/infinity-table";
import { useState, useEffect } from "react";

const RuleTable = ({
  data,
  onHandleRowClick,
  isLoading = false,
  hasMore = false,
  fetchData,
  selectionColumn,
  containerRef,
  after,
}) => {
  const { t } = useTranslation();
  const [sortedData, setSortedData] = useState(data);
  const [sortInfo, setSortInfo] = useState({});

  useEffect(() => {
    if (!sortInfo?.order) {
      setSortedData(data);
      return;
    }

    const { field, order } = sortInfo;
    const sorted = [...data].sort((a, b) => {
      const aVal = a[field];
      const bVal = b[field];

      if (field === "updatedAt") {
        return order === "ascend"
          ? new Date(aVal) - new Date(bVal)
          : new Date(bVal) - new Date(aVal);
      }

      if (typeof aVal === "string" && typeof bVal === "string") {
        return order === "ascend" ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal);
      }

      if (typeof aVal === "number" && typeof bVal === "number") {
        return order === "ascend" ? aVal - bVal : bVal - aVal;
      }

      return 0;
    });

    setSortedData(sorted);
  }, [data, sortInfo]);

  const handleTableChange = (_pagination, _filters, sorter) => {
    if (!sorter?.order) {
      setSortInfo({});
      setSortedData(data);
      return;
    }
    setSortInfo({ field: sorter.field || sorter.columnKey, order: sorter.order });
  };

  const columns = [
    {
      title: t("rule_management.table.name"),
      dataIndex: "title",
      key: "title",
      width: "30%",
      sorter: true,
      sortOrder: sortInfo.field === "title" ? sortInfo.order : null,
      render: (_, rule) => <TableCell title={rule.title} />,
    },
    {
      title: t("rule_management.table.subjects"),
      dataIndex: "subjectCount",
      key: "subjectCount",
      width: "15%",
      sorter: true,
      sortOrder: sortInfo.field === "subjectCount" ? sortInfo.order : null,
      render: (_, rule) => <TableCell text={rule.subjectCount} />,
    },
    {
      title: t("rule_management.table.type"),
      dataIndex: "condition",
      key: "condition",
      width: "15%",
      sorter: true,
      sortOrder: sortInfo.field === "condition" ? sortInfo.order : null,
      render: (_, rule) => (
        <TableCell
          text={
            rule.condition === "exclude"
              ? "Block all"
              : rule.condition === "only"
              ? "Allow only"
              : "N/A"
          }
        />
      ),
    },
    {
      title: t("rule_management.table.last_modified"),
      dataIndex: "updatedAt",
      key: "updatedAt",
      width: "25%",
      sorter: true,
      sortOrder: sortInfo.field === "updatedAt" ? sortInfo.order : null,
      render: (_, rule) => (
        <TableCell
          text={`${moment(rule.updatedAt).utc().format("DD MMM YYYY, HH:mm")}, UTC` || "N/A"}
        />
      ),
    },
  ];

  const tableColumns = selectionColumn ? [selectionColumn, ...columns] : columns;

  return (
    <InfinityTable
      data={sortedData}
      tableColumns={tableColumns}
      containerRef={containerRef}
      after={after}
      isLoading={isLoading}
      hasMore={hasMore}
      fetchData={fetchData}
      onHandleRowClick={onHandleRowClick}
      onChange={handleTableChange}
    />
  );
};

export default RuleTable;